<template>
  <div>
    <BreadCrumb class="bread" :breads="['广告管理','广告列表']"></BreadCrumb>
    <div class="wrap">
      <div class="header">
        <span class="nameFt">广告列表</span>
      </div>
      <div class="submit-form">
        <el-form :model="search" :inline="true" size="small" label-width="80px">
          <div class="submit-form__search">
            <el-form-item label="广告名称">
              <el-input v-model="search.title" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="广告类型">
              <el-select v-model="search.adv_type">
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建人">
              <el-input v-model="search.rel_name" maxlength="20"></el-input>
            </el-form-item>
          </div>
          <div class="submit-form__operate">
            <el-form-item>
              <el-button class="queryBtn" type="primary" @click="searchForm">查询</el-button>
              <el-button class="queryBtn" @click="reset">重置</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="operate-con">
        <el-button size="small" @click="openAdd">新增</el-button>
      </div>
      <div class="table-con">
        <el-table :data="tableList" stripe id="MainTables" style="width: 100%" v-loading="loading">
          <el-table-column label="序号" align="center" type="index" :index="indexMethod"></el-table-column>
          <el-table-column prop="title" label="广告标题" align="center"></el-table-column>
          <el-table-column prop="adv_type" label="广告类型" align="center">
            <div slot-scope="scope">{{adv_type[scope.row.adv_type]}}</div>
          </el-table-column>
          <el-table-column prop="brand" label="广告品牌" align="center"></el-table-column>
          <el-table-column prop="rel_name" label="创建人" align="center"></el-table-column>
          <el-table-column prop="created_at" label="创建时间" align="center"></el-table-column>
          <el-table-column prop="start" label="操作" align="center" width="260">
            <template slot-scope="scope">
              <el-button size="small" title="删除商品" @click="look(scope.row)">查看</el-button>
              <el-button
                size="small"
                type="danger"
                @click="removeClick(scope.row)"
                :disabled="scope.row.status == '删除'"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationWrap">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNum"
            :layout="pageLayout"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import apis from "@/config/apis";
import listMixin from "@/mixins/list";
import alert from "@/plugins/alert";
export default {
  name: "advertiement",
  mixins: [listMixin],
  data() {
    return {
      search: {},
      options: [
        {
          value: "ENABLE",
          label: "启用"
        },
        {
          value: "PROHIBIT",
          label: "禁用"
        }
      ],
      typeOptions: [
        {
          value: "IMAGE",
          label: "图片"
        },
        {
          value: "VIDEO",
          label: "视频"
        }
      ],
      adv_type: {
        IMAGE: "图片",
        VIDEO: "视频"
      }
    };
  },
  created() {
    this.search = Object.assign(this.search, this.$route.query);
    this.getData();
  },
  methods: {
    openAdd() {
      this.$router.push({
        path: "/index/applyAd"
      });
    },
    examine(row) {
      this.$router.push({
        path: "/index/applyAd",
        query: {
          id: row.id,
          operate: "update"
        },
        params: this.$route.query
      });
    },
    look(row) {
      this.$router.push({
        path: "/index/applyAd",
        query: {
          id: row.id,
          operate: "look"
        },
        params: this.$router.query
      });
    },
    removeClick(row) {
      const pid = row.id;
      alert.deleteAlert().then(next => {
        this.$axios.delete(apis.delete_advert + "/" + pid).then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.getData();
          }
        });
      });
    },
    searchForm() {
      this.search.page_index = 1;
      this.getData();
    },
    getData() {
      this.getTableData(apis.advert_list, "get", this.search);
    },
    reset() {
      this.search = {};
      this.search.page_index = 1;
      this.searchForm();
    }
  },
  components: {
    BreadCrumb
  }
};
</script>

<style lang="scss" scoped>
</style>